import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Button } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import LabeledCheckbox from 'oxyrion-ui/lib/LabeledCheckbox';
import { __ } from '../../Utils';
import API2 from '../../API2';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #f7f7f7;
  border-radius: ${rem(4)};
  width: calc(100% - 40px);
  padding-left: ${rem(20)};
  padding-right: ${rem(20)};
  padding-top: ${rem(5)};
  padding-bottom: ${rem(5)};
`;

const ContentWrapper = styled.div`
  -ms-box-orient: horizontal;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  align-items: flex;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex;
  width: ${rem(250)} ;
  min-width: ${rem(250)} ;
  height: ${rem(16)};
  // margin: ${rem(16)};
`;

const DisplayMore = styled.div`
  margin-left: auto;
  display: flex;
  width: ${rem(100)};
  flex-direction: column;
`;

const TitleWrapper = styled.div`
  padding-left: ${rem(10)};
  padding-top: ${rem(10)};
  font-size: ${rem(20)};
`;

const CheckboxWrapper = styled.div`
  margin: ${rem(14)};
  font-size: ${rem(11)};
`;

const brandsAllowedForTiting = [
  'FINKOLORA',
  'FLÜGGER',
  'TEKNOS IND. METAL',
  'TEKNOS IND. WOOD',
  'TIKKURILA DECO',
  'TIKKURILA IND. FLOOR',
  'TIKKURILA IND. METAL',
  'ZORKA',
];

export default class ToningCardFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersTypesAll: [],
      filtersTypes: [],
      showMore: false,
    };
  }

  async componentDidMount() {
    await this.fetchBrands();
  }

  async fetchBrands() {
    return API2.getB2BBrandsAction().then(res => {
      const data = res.tintingBrands.sort().map(brand => {
        return { label: brand, value: false };
      });

      const filtered = data.filter(d =>
        brandsAllowedForTiting.includes(d.label),
      );

      this.setState({
        filtersTypesAll: filtered.slice(0, 30),
        filtersTypes: filtered.slice(0, 10),
      });
    });
  }

  showMoreFilters() {
    const { filtersTypesAll, showMore } = this.state;

    if (showMore) {
      return this.setState({
        filtersTypes: filtersTypesAll.slice(0, 10),
        showMore: false,
      });
    }
    return this.setState({
      filtersTypes: filtersTypesAll,
      showMore: true,
    });
  }

  render() {
    const { filtersTypes, showMore, filtersTypesAll } = this.state;

    return (
      <Wrapper>
        <Header>
          <TitleWrapper>{__('Značka')}</TitleWrapper>
        </Header>
        <ContentWrapper>
          {filtersTypes.map((item, index) => (
            <CheckboxWrapper>
              <LabeledCheckbox
                checked={item.value}
                labelText={item.label}
                onChange={e => {
                  filtersTypes[index].value = e.target.checked;
                  this.setState(
                    {
                      filtersTypes,
                    },
                    () => {
                      this.props.onFilterChange(filtersTypes);
                    },
                  );
                }}
              />
            </CheckboxWrapper>
          ))}
        </ContentWrapper>

        {filtersTypes.length !== filtersTypesAll.length && (
          <DisplayMore>
            <Button small onClick={() => this.showMoreFilters()} primary>
              {showMore ? __('Zobraz menej') : __('Zobraz viac')}
            </Button>
          </DisplayMore>
        )}
      </Wrapper>
    );
  }
}

ToningCardFilter.propTypes = {
  onFilterChange: PropTypes.func,
};

ToningCardFilter.defaultProps = {
  onFilterChange: null,
};



// WEBPACK FOOTER //
// ./src/Components/ToningCardFilter/index.jsx